module.exports = __webpack_public_path__ + "static/SpinningHabitat1-1057f2d1ef08fafa914e227d47b9d63e.mp4";